import { render } from "./Recaptcha.vue?vue&type=template&id=0af46c75"
import script from "./Recaptcha.vue?vue&type=script&lang=js"
export * from "./Recaptcha.vue?vue&type=script&lang=js"

import "./Recaptcha.vue?vue&type=style&index=0&id=0af46c75&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__